import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IAdminAuditHistory, defaultValue } from 'app/shared/model/admin-audit-history.model';

export const ACTION_TYPES = {
  FETCH_ADMINAUDITHISTORY_LIST: 'adminAuditHistory/FETCH_ADMINAUDITHISTORY_LIST',
  FETCH_ADMINAUDITHISTORY: 'adminAuditHistory/FETCH_ADMINAUDITHISTORY',
  CREATE_ADMINAUDITHISTORY: 'adminAuditHistory/CREATE_ADMINAUDITHISTORY',
  UPDATE_ADMINAUDITHISTORY: 'adminAuditHistory/UPDATE_ADMINAUDITHISTORY',
  DELETE_ADMINAUDITHISTORY: 'adminAuditHistory/DELETE_ADMINAUDITHISTORY',
  RESET: 'adminAuditHistory/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IAdminAuditHistory>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type AdminAuditHistoryState = Readonly<typeof initialState>;

// Reducer

export default (state: AdminAuditHistoryState = initialState, action): AdminAuditHistoryState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_ADMINAUDITHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_ADMINAUDITHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_ADMINAUDITHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_ADMINAUDITHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_ADMINAUDITHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_ADMINAUDITHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_ADMINAUDITHISTORY):
    case FAILURE(ACTION_TYPES.CREATE_ADMINAUDITHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_ADMINAUDITHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_ADMINAUDITHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ADMINAUDITHISTORY_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_ADMINAUDITHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_ADMINAUDITHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_ADMINAUDITHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_ADMINAUDITHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/admin-audit-histories';

// Actions

export const getEntities: ICrudGetAllAction<IAdminAuditHistory> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_ADMINAUDITHISTORY_LIST,
  payload: axios.get<IAdminAuditHistory>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IAdminAuditHistory> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_ADMINAUDITHISTORY,
    payload: axios.get<IAdminAuditHistory>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IAdminAuditHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_ADMINAUDITHISTORY,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IAdminAuditHistory> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_ADMINAUDITHISTORY,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IAdminAuditHistory> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_ADMINAUDITHISTORY,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
